import Benachrichtigungscenter from './Benachrichtigungscenter';
import Ergebnisdateneingabe from './Ergebnisdateneingabe';
import Gruppenverwaltung from './Gruppenverwaltung';
import LieferadresseAnpassen from './LieferadresseAnpassen';
import Loginseite from './Loginseite';
import RueckmeldungAufgabenebene from './rueckmeldung/RueckmeldungAufgabenebene';
import RueckmeldungBerichte from './rueckmeldung/RueckmeldungBerichte';
import RueckmeldungFluss from './rueckmeldung/RueckmeldungFluss';
import RueckmeldungKsSchuelerebene from './rueckmeldung/RueckmeldungKsSchuelerebene';
import RueckmeldungKsVergleich from './rueckmeldung/RueckmeldungKsVergleich';
import RueckmeldungSchuelerebene from './rueckmeldung/RueckmeldungSchuelerebene';
import RueckmeldungVERAcheck from './rueckmeldung/RueckmeldungVERAcheck';
import Schuelerverwaltung from './Schuelerverwaltung';
import Startseite from './Startseite';
import Templateseite from './Templateseite';
import Veraportal from './Veraportal';
import {ISessionvariablen} from "./Interfaces";
import Datenimport from "./Datenimport";
import Gruppenzuordnung from "./Gruppenzuordnung";
import Koordinatorenansicht from "./Koordinatorenansicht";
import SchuleVerwalten from "./SchuleVerwalten";
import Statusuebersicht from "./Statusuebersicht";
import Wasserstand from "./Wasserstand";
import Utilities from "./Utilities";
import Statistik from "./Statistik";
import Tooltip from './Tooltip';

const pageRegistry: Record<string, { getInstance(sessionvariablen?: ISessionvariablen): any; }> = {
    'benachrichtigungscenter-page': Benachrichtigungscenter,
    'cbt-zugangscodeliste-page': Veraportal,
    'datenimport-page': Datenimport,
    'ergebnisdateneingabe-page': Ergebnisdateneingabe,
    'gruppen-verwaltung-page': Gruppenverwaltung,
    'gruppen-zuordnung-page': Gruppenzuordnung,
    'koordinatorenansicht-page': Koordinatorenansicht,
    'lieferadresse-anpassen-page': LieferadresseAnpassen,
    'materialien-page': Veraportal,
    'rueckmeldung-berichte-page': RueckmeldungBerichte,
    'rueckmeldung-ks-schuelerebene-page': RueckmeldungKsSchuelerebene,
    'rueckmeldung-ks-vergleich-page': RueckmeldungKsVergleich,
    'rueckmeldung-lh-aufgabenebene-page': RueckmeldungAufgabenebene,
    'rueckmeldung-lh-fluss-page': RueckmeldungFluss,
    'rueckmeldung-lh-schuelerebene-page': RueckmeldungSchuelerebene,
    'rueckmeldung-veracheck-page': RueckmeldungVERAcheck,
    'schuelerverwaltung-page': Schuelerverwaltung,
    'schule-verwalten-page': SchuleVerwalten,
    'startseite-page': Startseite,
    'statusuebersicht-page': Statusuebersicht,
    'templateseite-page': Templateseite,
    'videotutorials-page': Veraportal,
    'wasserstand-page': Wasserstand,
    'login-page': Loginseite
};

document.addEventListener('DOMContentLoaded', () => {
    try {
        Tooltip.getInstance();
        const sessionvariablen: ISessionvariablen = JSON.parse(document.body.getAttribute('data-session')) ?? {};
        pageRegistry[document.body.id]?.getInstance(sessionvariablen);
    } catch (e) {
        Utilities.errorToSentry(e);
        console.error(`Failed to get instance for page: ${document.body.id}`, e);
    }
});
